export class Settings {
  static readonly IdleTimeoutSeconds: number = 30 * 60;
  static readonly IdleTimeoutLogoutSeconds: number = 60;
}

export class Data {
  static readonly SubscriperTargetGroupId: number = 4;
  static readonly NotLoggedInTargetGroupId: number = 1;
  static readonly AjassaOnlineMagazineId: number = 1;
}

// CoreSkills-specific constants
export const OCR_MAX_PDF_BYTES = 50 * 1024 * 1024; // 50 MB
export const LONG_TIMEOUT_MS = 300000; // 5 minutes
export const CORESKILLS_DEFAULT_ORG_ID = 'GiNR9B0KQ7bAKcUTPRpC';

export default {
  Settings,
  Data,
  OCR_MAX_PDF_BYTES,
  LONG_TIMEOUT_MS,
  CORESKILLS_DEFAULT_ORG_ID,
};
